import e, { Component as t } from "react";
import { throttledResize as r } from "../../../utils/dom/index.js";
import { GlobalListener as n } from "../../offscreen/GlobalListener/GlobalListener.js";
import { componentName as o } from "../../../utils/bem/index.js";
function i(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function c(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function s(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function a(e) {
  return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function l(e, t) {
  return (l = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var u = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && l(e, t);
  }(h, t);
  var u,
    f,
    p,
    d = (u = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = a(h);
      if (u) {
        var n = a(this).constructor;
        t = Reflect.construct(r, arguments, n);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : i(this);
    });
  function h() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, h), e = d.apply(this, arguments), s(i(e), "container", void 0), s(i(e), "selector", void 0), s(i(e), "_handleClick", function (t) {
      if (!e.props.disabled) {
        var r = parseInt(t.target.getAttribute("data-index"));
        e.props.onClick(e.props.labels[r], r);
      }
    }), s(i(e), "_throttledResize", function () {
      return r(e.componentDidUpdate.bind(i(e)));
    }), s(i(e), "updateSelector", function () {
      if (e.selector && e.container) {
        var t = e.container.children[e.props.selected];
        if (t) {
          var r = t.getBoundingClientRect(),
            n = e.container.getBoundingClientRect();
          e.selector.style.width = "".concat(r.width, "px"), e.selector.style.left = "".concat(r.left - n.left, "px");
        }
      }
    }), s(i(e), "_receiveContainer", function (t) {
      return e.container = t;
    }), s(i(e), "_receiveSelector", function (t) {
      return e.selector = t;
    }), e;
  }
  return f = [{
    key: "componentDidMount",
    value: function value() {
      this.updateSelector();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.updateSelector();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
        r = o("rocker-button", this.props.className, {
          frameless: "frameless" in this.props && !1 !== this.props.frameless,
          withTrack: "withTrack" in this.props && !1 !== this.props.withTrack,
          noSelection: "number" != typeof this.props.selected || this.props.selected < 0
        });
      return e.createElement("div", {
        className: r,
        ref: this._receiveContainer
      }, e.createElement(n, {
        listenOn: window,
        types: "resize",
        onResize: this._throttledResize
      }), this.props.labels.map(function (r, n) {
        return e.createElement("div", {
          className: "rocker-button__item qa-rocker-button-item",
          "data-index": n,
          key: n,
          onClick: t._handleClick
        }, r);
      }), e.createElement("div", {
        className: "rocker-button__selector",
        ref: this._receiveSelector
      }));
    }
  }], c(h.prototype, f), p && c(h, p), h;
}(t);
s(u, "displayName", "RockerButton");
export { u as RockerButton };